import { API_URI } from "@/helpers/config";

export default class Artwork {
    constructor(data) {
        Object.assign(this, data);
    }
    get price() {
        const model = this;
        const av = (model.availability || "").replace(/.*\$((\d|,)*).*/, '$1');
        return parseInt(av.replace(',', '')) || 0;
    }
    get sold() {
        const model = this;
        if (!model.availability) return false;
        return model.availability.toLowerCase().includes("sold");
    }
    get fullImage() {
        const model = this;
        if (! model.image) return null;
        return API_URI + "/" + model.image;
    }
    get thumbnail() {
        const model = this;
        if (! model.image) return null;
        const thumb = model.image.replace('sites/default/files/', 'sites/default/files/imagecache/artwork_thumb/');
        return API_URI + "/" + thumb;
    }
    get url() {
        const model = this;
        return {name: 'artists/artwork', params: {artistSlug: model.artist.name, selectedArtworkSlug: model.slug}};
    }
    get slug() {
        const model = this;
        const escapedTitle = model.title.toString()
            .replace(/[^A-Za-z 0-9 .,!()\-_;:<>|}{[\]~]+?/g, '_');
        return `${escapedTitle} | ${model.nid}`;
    }
}
